<template>
  <div   class="slider w-slider">
    <div class="mask maskedit w-slider-mask  " >

       
      

      <div class="  w-slide" v-if="slideIndex==0">
        <div class="w-container">
          <h1 class="slider-statement">Hashkitten&#x27;s principles matter in today&#x27;s world</h1>
          <div class="w-row">
            <div class="column-9 w-col w-col-4 w-col-small-small-stack"><img src="@/assets/images/decentralized.svg" width="70" height="70" alt="decentralized by Javad from the Noun Project" class="principle-icon">
              <h2 class="carousel values">De-kitten-tralized</h2>
              <p class="slider-paragraph">As an ownerless neutral smart contract on Ethereum, users can self-validate all the code of HashKittens.  As native token smart contract, no bridges or IOUs are needed so your Meowws are controlled by your keys alone.</p>
            </div>
            <div class="column-10 w-col w-col-4 w-col-small-small-stack"><img src="@/assets/images/smart-contract.svg" width="70" height="70" alt="smart contract by James Fok from the Noun Project" class="principle-icon">
              <h2 class="carousel values">Contract Compatible</h2>
              <p class="slider-paragraph">Hashkittens is a powerfully extensible ERC20 smart contract on which users and DeFi apps can build on top. This includes decentralized exchangs, mining pools, and bridges to others networks.   A commodity forged from energy for the DeFi community to use how they see fit. </p>
            </div>
            <div class="column-11 w-col w-col-4 w-col-small-small-stack"><img src="@/assets/images/coins.svg" width="70" height="70" alt="Coins by Viktor Fedyuk (Tim P) from the Noun Project" class="principle-icon">
              <h2 class="carousel values">Neutral Money</h2>
              <p class="slider-paragraph">All HashKittens are mined using Proof of Work. The proofs are submitted and stored on-chain for a self-verifying historical reference to the neutrality of the currency.  This makes it mathematically verifiably neutral.   </p>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="left-arrow w-slider-arrow-left" @click="decrementSlideIndex()">
      <div class="icon-2 w-icon-slider-left"></div>
    </div>
    <div class="right-arrow w-slider-arrow-right" @click="incrementSlideIndex()">
      <div class="icon w-icon-slider-right"></div>
    </div>
    <div class="slide-nav w-slider-nav w-slider-nav-invert"></div>
  </div>
  
</template>


<script>

const MAX_SLIDE = 0

export default {
  name: 'Carousel',
  props: [],
  data() {
    return {
      slideIndex:0
    }
  },
  created(){
    setInterval(this.incrementSlideIndex,24000);
  },
  methods: {
    incrementSlideIndex()
    {
      this.slideIndex++;
      if(this.slideIndex>MAX_SLIDE) this.slideIndex=0;
    },
      decrementSlideIndex()
    {
      this.slideIndex--;
      if(this.slideIndex<0) this.slideIndex=MAX_SLIDE;
    }
  }
}
</script>
